import React, {useState} from 'react';
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import {Link} from "react-router-dom";
import {useUser} from "./Components/UserProvider";
import Avatar from './Components/Avatar';
import { FormattedMessage } from 'react-intl';
import { LanguageSwitcherBasic } from './i18n';

export default function Header({ }) {
    const user = useUser();
    return <div className="header mb-3">
        <LanguageSwitcherBasic className="me-3" />
        <div>
            <FormattedMessage id="LOGGED_IN" values={{ user: <b>{user.name}</b> }} /><br />
            <FormattedMessage id="NOT_YOU" values={{ a: text => <Link to="/logout">{text}</Link> }} />
        </div>
        <Avatar user={user} className="ms-3" />
    </div>;
}
